/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */

/**
 * equalization_interest_reference_date: The date used for calculating equalization interest. This is also the date stored on the interest transactions once they are part of a cash equalization.
 */
export type EqualizationConfigDateEnum = typeof EqualizationConfigDateEnum[keyof typeof EqualizationConfigDateEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EqualizationConfigDateEnum = {
  equalization_capital_call_date: 'equalization_capital_call_date',
  equalization_capital_call_date_plus_one: 'equalization_capital_call_date_plus_one',
  equalization_distribution_date: 'equalization_distribution_date',
  closing_date: 'closing_date',
} as const;
